import React from 'react'
import { Typography } from '@mui/material'
import { CategoriesOnlyViewProps } from '../types'
import {
  WebinarRegistrationPrompt,
  WebinarInfoPanel,
  getWebinarIdFromNickname,
  getRegistrationUrlFromNickname,
} from '../components'

const CategoriesOnlyView: React.FC<CategoriesOnlyViewProps> = ({
  selectedCategory,
  isCategoryAccessible,
  categoryInfo,
  webinarTypes,
  onRegistrationSuccess,
}) => {
  if (!selectedCategory) {
    // Show info panels for all webinar types when no category is selected
    const uniqueNicknames = Array.from(new Set(webinarTypes.map((t) => t.nickname)))
    if (uniqueNicknames.length === 0) {
      return <Typography>No webinars available at this time.</Typography>
    }
    return (
      <>
        {uniqueNicknames.map((nickname) => {
          const type = webinarTypes.find((t) => t.nickname === nickname)
          if (!type) return null
          return (
            <WebinarInfoPanel
              key={nickname}
              categoryName={type.name}
              description={type.description}
              schedule={type.schedule}
            />
          )
        })}
      </>
    )
  }

  if (isCategoryAccessible(selectedCategory)) {
    return (
      <WebinarRegistrationPrompt
        categoryName={selectedCategory}
        description={categoryInfo?.description}
        schedule={categoryInfo?.schedule}
        webinarId={getWebinarIdFromNickname(selectedCategory, webinarTypes)}
        registrationUrl={getRegistrationUrlFromNickname(selectedCategory, webinarTypes)}
        onRegistrationSuccess={onRegistrationSuccess}
      />
    )
  }

  return (
    <>
      {categoryInfo && (
        <WebinarInfoPanel
          categoryName={selectedCategory}
          description={categoryInfo.description || ''}
          schedule={categoryInfo.schedule || ''}
        />
      )}
      <Typography>
        No sessions scheduled for this category. Please select another category or check back later.
      </Typography>
    </>
  )
}

export default CategoriesOnlyView
